import NeptuneElement from '../../../NeptuneElement.js';

class SidenavItem extends NeptuneElement {

    templateMarkup = `
        <li>
            <a>
                <span class="avatar" hidden></span>
                <i class="fa-regular"></i>
                <span class="font-size-md"></span>
                <i class="fa-solid"></i>
            </a>
        </li>
    `;

    componentCssUrl = '/src/components/chrome/sidenav/sidenavItem/sidenav-item.css';

    async connectedCallback() {
        await super.connectedCallback();
        this.processInitialAttributesAfterRender(SidenavItem.observedAttributes);
    }

    async disconnectedCallback() {
        await super.disconnectedCallback();
    }

    static get observedAttributes() {
        return ['label', 'route', 'icon', 'active', 'expanded', 'submenu', 'collapsed', 'avatarText'];
    }

    async setEventListeners() {
        this.linkElement = this.shadowRoot.querySelector('a');
        this.handleClickBound = this.#handleClick.bind(this);
        
        this.linkElement?.addEventListener('click', this.handleClickBound);
    }

    async removeEventListeners() {
        this.linkElement?.removeEventListener('click', this.handleClickBound);
        
        this.linkElement = null;
        this.handleClickBound = null;
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (!this.isRendered) {
            return;
        }
        this.processAttribute(name, oldValue, newValue);
    }

    processAttribute(name, oldValue, newValue) {
        const link = this.shadowRoot?.querySelector('a');
        const label = this.shadowRoot?.querySelector('span.font-size-md');
        const avatar = this.shadowRoot?.querySelector('span.avatar');
        let iconLeft = this.shadowRoot?.querySelector('i:first-of-type');
        const iconRight = this.shadowRoot?.querySelector('i:last-of-type');

        if (!link || !label) {
            throw new Error(`SidenavItem: Required elements not found in shadow DOM. Missing: ${!link ? 'link' : ''} ${!label ? 'label' : ''}`);
        }
        switch (name) {
            case 'label': {
                const labelText = newValue || '';
                label.textContent = labelText;
                const isCollapsed = this.hasAttribute('collapsed');
                if (isCollapsed) {
                    link.title = labelText;
                }
                break;
            }
            case 'route': {
                link.href = newValue || '#';
                break;
            }
            case 'icon': {
                if (!iconLeft) {
                    iconLeft = document.createElement('i');
                    iconLeft.className = 'fa-regular';
                    link.insertBefore(iconLeft, link.querySelector('span.font-size-md'));
                }
                if (newValue) {
                    iconLeft.className = `fa-solid ${newValue}`;
                    iconLeft.removeAttribute('hidden');
                } else {
                    iconLeft.className = 'fa-regular';
                    iconLeft.setAttribute('hidden', '');
                }
                break;
            }
            case 'avatarText': {
                if (newValue && avatar) {
                    avatar.textContent = newValue;
                    avatar.removeAttribute('hidden');
                    if (iconLeft) {
                        iconLeft.remove();
                    }
                } else if (avatar) {
                    avatar.setAttribute('hidden', '');
                }
                break;
            }
            case 'collapsed': {
                const isCollapsed = this.hasAttribute('collapsed');
                const labelText = this.getAttribute('label') || '';
                link.title = isCollapsed ? labelText : '';
                break;
            }
            case 'submenu':
            case 'active':
            case 'expanded': {
                const isActive = this.hasAttribute('active');
                const isExpanded = this.hasAttribute('expanded');
                const hasSubmenu = this.hasAttribute('submenu');

                if (hasSubmenu) {
                    iconRight.className = `fa-solid ${isExpanded ? 'fa-chevron-left' : 'fa-chevron-right'}`;
                    iconRight.removeAttribute('hidden');
                } else {
                    iconRight.setAttribute('hidden', '');
                }
                this.setAttribute('state', isActive ? 'active' : isExpanded ? 'expanded' : 'default');
                break;
            }
            default: {
                break;
            }
        }
    }

    #handleClick(event) {
        const hasSubmenu = this.hasAttribute('submenu');

        if (hasSubmenu) {
            event.preventDefault();
            const isExpanded = this.hasAttribute('expanded');
            this.toggleAttribute('expanded', !isExpanded);

            this.dispatchEvent(new CustomEvent('neptune-sidenav-item-toggle', {
                bubbles: true,
                composed: true,
                detail: {
                    expanded: !isExpanded,
                    label: this.getAttribute('label')
                }
            }));
        } else {
            event.preventDefault();
            this.dispatchEvent(new CustomEvent('neptune-sidenav-item-click', {
                bubbles: true,
                composed: true,
                detail: {
                    id: this.getAttribute('data-item-id'),
                    route: this.getAttribute('route'),
                    label: this.getAttribute('label')
                }
            }));
        }
    }
}

if (!customElements.get('neptune-sidenav-item')) {
    customElements.define('neptune-sidenav-item', SidenavItem);
}

export default SidenavItem;